<template>
    <router-view v-if="isPublic" />
    <div v-else class="app-cont">
        <!-- "Viewing as …" strip while impersonating (fixed; pushes #app down via html.gs-imp). -->
        <impersonation-banner />
        <side-nav />
        <div class="app-main">
            <header-component />
            <!-- The routed view gets its own wrapper because header.vue is a fragment: it
                 returns .header AND <gsai-window>, whose root is an empty div until the AI
                 window opens. Both land here as siblings, so a rule that hands "every child
                 of .app-main" the leftover height gave that empty div an equal share of it
                 and opened a grey band between the header and the page. -->
            <div class="app-view">
                <router-view v-if="isMounted" />
            </div>
            <div class="conditions__loader-container" v-if="isLoading">
                <loader :size="'large'" :type="'infinite-spinner'"></loader>
            </div>
        </div>
        <!-- Hosted here rather than on a view so the rail's Chat button works from every
             page; it scopes itself to the loan in the route. -->
        <loan-chat-drawer />
        <swift-chat-drawer />
    </div>
</template>

<script>
    import { Loader } from "@progress/kendo-vue-indicators";

    import header from './components/header.vue';
    import SideNav from './components/SideNav.vue';
    import LoanChatDrawer from './components/LoanChatDrawer.vue';
    import SwiftChatDrawer from './components/SwiftChatDrawer.vue';
    import ImpersonationBanner from './components/impersonation/ImpersonationBanner.vue';

    import auth from './authConfig.js';

    var emitter = require('tiny-emitter/instance');
    export default {
   
   
        data() {
            return {
                isLoading: true,
                isMounted: false,
                // Public pages (realtor letter) render alone: no sign-in, no side nav / header / chat.
                isPublic: window.location.pathname.toLowerCase().startsWith('/realtorletter'),
            
            }
        },
       async created() {
          if (this.isPublic) { this.isMounted = true; this.isLoading = false; return; }
    
          const msalAppInstance = await auth.init();

         msalAppInstance.handleRedirectPromise().then(async (tokenRes) => {
            this.fetchData();
          });
 
    },
    methods: {
  
      async fetchData() {
        let sessionLoanId = sessionStorage.getItem('selectedloan');
        let loanIdParam = this.$route.query.id;

        if (!sessionLoanId) {
          sessionStorage.setItem('selectedloan', loanIdParam);
          this.isMounted = true;
          this.isLoading = false;
        } else {
          if (loanIdParam) {
            if (loanIdParam !== sessionLoanId) {

              sessionStorage.setItem('selectedloan', loanIdParam);

              await this.$store.dispatch('updateLoan');
              await this.$store.dispatch('getConditions');
              await this.$store.dispatch('getAttachments');
              await this.$store.dispatch('getDocuments');
            }

            this.isMounted = true;
            this.isLoading = false;
          }
        }
      }
    },
        components: {
            'header-component': header,
            'side-nav': SideNav,
            'loan-chat-drawer': LoanChatDrawer,
            'swift-chat-drawer': SwiftChatDrawer,
            'impersonation-banner': ImpersonationBanner,
            'loader': Loader
        }
    }
</script>

<style>
    @import '../src/assets/css/cgslight.css';
    @import '../src/assets/css/site.css';
    @import '../src/assets/css/sharedDesign.css';

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100vh;
    }

    nav {
        padding: 30px;
    }

    nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    nav a.router-link-exact-active {
        color: #42b983;
    }

    .app-cont {
        height: 100%;
        display: flex;
        flex-direction: row;
    }

    /* .app-main takes over the column role the whole app used to have, so every routed view
       keeps the exact same height budget it had before (header takes what it needs, the view
       gets the rest). Nothing inside the views needs to change. */
    .app-main {
        flex: 1 1 auto;
        min-width: 0;
        min-height: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    /* Owns the leftover height below the header and passes it to the routed view.
       Anything else the header contributes as a sibling root sizes to its content. */
    .app-view {
        flex: 1 1 auto;
        min-width: 0;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .app-main > :not(.app-view):not(.header) {
        flex: 0 0 auto;
    }

    @media only screen and (max-width: 500px) and (orientation: portrait) {
      #app {
        height: unset;
      }
    }

    /* SideNav hides itself at this breakpoint (see SideNav.vue) — go back to a plain column
       so header.vue's mobile-fallback nav row has the full width. */
    @media only screen and (max-width: 630px) {
      .app-cont {
        flex-direction: column;
      }
    }
</style>
